import moment from 'moment';

export class DateUtils {
    public static dateFormatConvert(date: string, initialFormat: string, returnFormat: string) {
      return moment(date, initialFormat).format(returnFormat);
    }
}
